import { useTranslation } from "react-i18next"
import { Box, Checkbox, Icon, IconButton, InputAdornment, List, ListItem, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../../../utils/icons"
import { useStyles } from "../../../styles"
import { CheckCell } from "../../../../detail/components/checkCell"
import React, { SetStateAction, useEffect, useRef, useState } from "react"
import { useFilter } from "../../../../../../../hooks/filter"
import { fileTypeText, formatFilterAdd, formatFilterList } from "../../allFiles/constans/menu"
import { InputModel } from "../../../../../../../utils/types"
import { HeaderRowCheckBox } from "../../../../../../calendar/pages/main/components/headerRowCheckBox"
import { UserFilesSections } from "../enums/userSection"
import { FilterBody } from "../../../../../../../hooks/filter/typing"
import { returnQuery } from "../../../../../../../utils/methods/returnQuery"
import { filesManagerServiceFetch } from "../../../../../../../utils/constants/callService"
import { formatUserFilesList, formatUserFilesToAddList, formatUserWithFilesList } from "../../../../../../../service/filesManager/format"
import { RowUserFileAddedItem, RowUserFileToAddItem, RowUserItem } from "../../../../../../../service/filesManager/response"
import { getLocalStorage } from "../../../../../../../utils/crud/crypt"
import { Roles, Types } from "../../../../../../../utils/enums"
import { formData } from "../../allFiles/constans/format"
import { addFileBody, addUserFilesBody, deleteFilesBody } from "../../../../../../../service/filesManager/body"

const useTable = ({ handleUserDetail, setSection, filterFileList, userId, section }: { section: UserFilesSections; userId: number | null; filterFileList: FilterBody; handleUserDetail: (id: number, user: { name: string; role: string; area: string[]; department: string[]; userType: string; }) => void; setSection: (value: SetStateAction<UserFilesSections>) => void }) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const [tableLoading, setTableLoading] = useState(false)
    const [tableAddLoading, setTableAddLoading] = useState(false)
    const [tableUserLoading, setTableUserLoading] = useState(false)
    const [loadingSaveFiles, setLoadingSaveFiles] = useState(false)
    const [loadingDeleteFiles, setLoadingDeleteFiles] = useState(false)
    const [loadingSaveUserFiles, setLoadingSaveUserFiles] = useState(false)
    const state: { id: number; role: Roles } = getLocalStorage()
    const [totalPages, setTotalPages] = useState(0)
    const [totalPagesAdd, setTotalPagesAdd] = useState(0)
    const [totalItemsAdd, setTotalItemsAdd] = useState(0)
    const [totalPagesDetail, setTotalPagesDetail] = useState(0)
    const [arrayEdits, setArrayEdits] = useState<{ idFile: number, seeFile?: boolean, downloadFile?: boolean }[]>([])
    const [flagCheckedSee, setFlagCheckedSee] = useState(false)
    const [flagCheckedDownload, setFlagCheckedDownload] = useState(false)
    const refTime = useRef<NodeJS.Timeout | null>(null)
    const refTimeSecond = useRef<NodeJS.Timeout | null>(null)
    const refTimeDetail = useRef<NodeJS.Timeout | null>(null)
    const [openModal, setOpenModal] = useState<{
        open: boolean
        title: string
        description: string
        id: string | number
        confirm: () => void
        children: JSX.Element | undefined
        back?: () => void
    }>({
        id: '',
        open: false,
        title: '',
        description: '',
        confirm: () => { },
        children: undefined,
        back: undefined
    })

    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const closeModal = () => {
        setOpenModal((prev) => ({
            ...prev,
            open: false,
            confirm: () => { },
            children: undefined,
            removeButtons: false
        }))
    }

    const filterAddFiles = useFilter({ formatFilter: formatFilterAdd })

    const input = {
        search: {
            label: 'filesManager.tags.search',
            translate: true,
            name: 'search',
            value: null,
            wrapChildren: ({ children, id }) => {
                return React.cloneElement(children, {
                    id,
                    InputProps: {
                        ...(children.props.InputProps ?? {}),
                        endAdornment: (
                            <InputAdornment position="end">
                                {icons('search')}
                            </InputAdornment>
                        ),
                    },
                });
            }
        },
        fileType: {
            label: 'filesManager.tags.fileType',
            translate: true,
            name: 'fileType',
            type: 'filter-select',
            items: fileTypeText.map((e) => ({
                ...e,
                value: e.value,
            })),
            value: null,
        },
        from: {
            label: 'general.tags.from',
            translate: true,
            name: 'from',
            type: 'date',
            value: null,
            rest: {
                max: 'to',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6
            },
            wrapChildren: ({ children, id }) => {
                return (
                    <Box>
                        <Typography sx={styles.createTitle}>{t('filesManager.tags.creationDate')}</Typography>
                        <Box>{children}</Box>
                    </Box>
                )
            }
        },
        to: {
            label: 'general.tags.to',
            translate: true,
            name: 'to',
            type: 'date',
            value: null,
            rest: {
                min: 'from',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6
            },
            wrapChildren: ({ children, id }) => {
                return (
                    <Box sx={styles.fromBox}>
                        <Box>{children}</Box>
                    </Box>
                )
            }
        }
    } as { [x: string]: InputModel }

    const [rowList, setRowList] = useState<RowUserItem[]>([]);

    const detailFilter = useFilter({ formatFilter: formatFilterAdd })

    const [rowDetail, setRowDetail] = useState<RowUserFileAddedItem[]>([]);
    const [isChecked, setIsChecked] = useState(false)
    const [deleteSelected, setDeletedSelected] = useState<number[]>([])
    const [noDeleteSelected, setnoDeletedSelected] = useState<number[]>([])

    const [viewFile, setViewFile] = useState<{ fileKey: string, fileName: string } | null>(null);

    const [isCheckedSee, setIsCheckedSee] = useState(false)
    const [selectedSee, setSelectedSee] = useState<number[]>([])
    const [noSelectedSee, setnoSelectedSee] = useState<number[]>([])

    const [isCheckedDownload, setIsCheckedDownload] = useState(false)
    const [selectedDownload, setSelectedDownload] = useState<number[]>([])
    const [noSelectedDownload, setnoSelectedDownload] = useState<number[]>([])

    const prevSelectedSeeRef = useRef<number[]>([]);
    const prevNoSelectedSeeRef = useRef<number[]>([]);

    const disabledAddFiles = !(isCheckedSee || selectedSee.length);
    const disabledSaveUserFiles = (
        flagCheckedSee === false &&
        flagCheckedDownload === false &&
        arrayEdits.length === 0
    )
        ||
        (
            flagCheckedSee === true &&
            isCheckedSee === false &&
            selectedSee.length === 0
        );

    const unSelectOrSelectAllFiles = ({ value }: { value: boolean }) => {
        if (value) {
            setFlagCheckedDownload(true)
            setFlagCheckedSee(true)
            setIsCheckedDownload(true)
            setIsCheckedSee(true)
        } else {
            setFlagCheckedDownload(true)
            setFlagCheckedSee(true)
            setIsCheckedDownload(true)
            setIsCheckedSee(true)
            setIsCheckedDownload(false)
            setIsCheckedSee(false)
        }
    };


    const handleSelect = ({ id, value, name, otherValue }: { id: number; value: boolean; name: 'seeFile' | 'downloadFile', otherValue: boolean }) => {

        setArrayEdits((prev) => {
            const index = prev.findIndex((item) => item.idFile === id);

            const confirmAndUpdate = (callback: () => void) => {
                setOpenModal((prev) => ({
                    ...prev,
                    open: true,
                    title: t('filesManager.modal.titles.deleteSettings'),
                    description: t('filesManager.modal.description.deleteSettings'),
                    confirm: () => {
                        callback()
                        closeModal()
                    },
                    children: undefined,
                    back: closeModal,
                }))
            };

            //No existe el id
            if (index === -1) {
                if (name === 'seeFile') {
                    if (!value && otherValue) {
                        // 1.1 Preguntar y agregar ambos en false
                        confirmAndUpdate(() => {
                            setArrayEdits((p) => [...p, { idFile: id, seeFile: false, downloadFile: false }]);
                        });
                        return prev;
                    }
                    if (value) {
                        // 1.2 seeFile true y downloadFile false
                        return [...prev, { idFile: id, seeFile: true, downloadFile: false }];
                    }
                    // 1.3 Ambos en false
                    return [...prev, { idFile: id, seeFile: false, downloadFile: false }];
                }

                if (name === 'downloadFile') {
                    if (!value) {
                        // 2.1 downloadFile false y seeFile = otherValue
                        return [...prev, { idFile: id, downloadFile: false, seeFile: otherValue }];
                    }
                    // 2.2 downloadFile true y seeFile = otherValue
                    return [...prev, { idFile: id, downloadFile: true, seeFile: otherValue }];
                }
            }

            //Ya existe el id
            if (index !== -1) {
                const updated = [...prev];

                if (name === 'seeFile') {
                    if (!value && updated[index].downloadFile) {
                        // 3.1 Preguntar y poner ambos en false
                        confirmAndUpdate(() => {
                            setArrayEdits((p) => {
                                const upd = [...p];
                                upd[index] = { ...upd[index], seeFile: false, downloadFile: false };
                                return upd;
                            });
                        });
                        return prev;
                    }
                    if (value) {
                        // 3.2 seeFile true y downloadFile false
                        updated[index] = { ...updated[index], seeFile: true, downloadFile: false };
                        return updated;
                    }
                    // 3.3 Ambos en false
                    updated[index] = { ...updated[index], seeFile: false, downloadFile: false };
                    return updated;
                }

                if (name === 'downloadFile') {
                    if (!value) {
                        // 4.1 downloadFile false
                        updated[index] = { ...updated[index], downloadFile: false };
                        return updated;
                    }
                    // 4.2 downloadFile true
                    updated[index] = { ...updated[index], downloadFile: true };
                    return updated;
                }
            }

            return prev;
        });
    }

    const deletedUsersSelecteds = () => {
        setOpenModal((prev) => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.deleteFile', { count: deleteSelected.length }),
            description: t('filesManager.modal.description.deletePermissionDescription'),
            children: undefined,
            back: closeModal,
            confirm: () => {
                handleDeleteSelecteds()
                closeModal()
            }
        }))

    }

    const handleDeleteSelecteds = async () => {
        setLoadingDeleteFiles(true)
        const body = deleteFilesBody({ userId: Number(userId), deleteSelected, isChecked, noDeleteSelected })

        const response = await filesManagerServiceFetch.deleteFilesToUser({ body: body, query: isChecked ? returnQuery({ ...detailFilter.query, filter: detailFilter.query.filter?.replaceAll('+', '%2B') }, formData) : undefined })

        if (response.code == '00') {
            setOpenModal((prev) => ({
                ...prev,
                open: true,
                title: t('filesManager.modal.titles.confirmation'),
                description: t('filesManager.modal.description.deletedFiles', { count: deleteSelected.length }),
                confirm: () => {
                    cleanData();
                    getUserFilesAlreadyAdded();
                    closeModal();
                },
                children: undefined,
                back: undefined,

            }))
        }

        setLoadingDeleteFiles(false)
    }

    const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDeletedSelected([]);
        setnoDeletedSelected([]);
        if (event.target.checked) {
            setIsChecked(true)
        } else {
            setIsChecked(false)
        }
    };

    const handleHeaderSeeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (section == UserFilesSections.DETAIL) {
            setFlagCheckedSee(true)
        }

        if (event.target.checked) {
            setIsCheckedSee(true)
            setSelectedSee([]);
            setnoSelectedSee([]);
        } else {
            if (
                (
                    (
                        (!isCheckedDownload && selectedDownload.length) || (isCheckedDownload)
                    ) && section == UserFilesSections.ADD_FILE
                ) || section == UserFilesSections.DETAIL
            ) {
                setOpenModal((prev) => ({
                    ...prev,
                    open: true,
                    title: t('filesManager.modal.titles.deleteSettings'),
                    description: t('filesManager.modal.description.deleteSettings'),
                    confirm: () => {
                        setSelectedDownload([]);
                        setnoSelectedDownload([]);
                        setIsCheckedSee(false)
                        setIsCheckedDownload(false)
                        setSelectedSee([]);
                        setnoSelectedSee([]);

                        if (section == UserFilesSections.DETAIL) {
                            setIsCheckedDownload(true)
                            setIsCheckedDownload(false)
                            setFlagCheckedDownload(true)
                        }

                        closeModal()
                    },
                    children: undefined,
                    back: closeModal,
                }))
            } else {
                setIsCheckedSee(false)
                setSelectedSee([]);
                setnoSelectedSee([]);
            }
        }
    };

    const handleHeaderDownloadChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (section == UserFilesSections.DETAIL) {
            setFlagCheckedDownload(true)
        }

        setSelectedDownload([]);
        setnoSelectedDownload([]);
        if (event.target.checked) {
            setIsCheckedDownload(true)
        } else {
            setIsCheckedDownload(false)
        }
    };

    const [rowAddFile, setRowAddFile] = useState<RowUserFileToAddItem[]>([]);

    const handleAddFiles = () => {
        setOpenModal((prev) => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.youSureAddFilesSelected'),
            confirm: () => {
                handleSaveFilesToAdd()
                closeModal()
            },
            children: undefined,
            back: closeModal,
        }))
    }

    const handleSaveFilesToAdd = async () => {
        setLoadingSaveFiles(true)
        const body = addFileBody({ selectedDownload, userId: Number(userId), isCheckedDownload, isCheckedSee, noSelectedDownload, noSelectedSee, selectedSee })

        const response = await filesManagerServiceFetch.addMyFilesToUser({ body: body, query: isCheckedSee ? returnQuery({ ...filterAddFiles.query, filter: filterAddFiles.query.filter?.replaceAll('+', '%2B') }, formatFilterList) : undefined })

        if (response.code == '00') {
            setOpenModal((prev) => ({
                ...prev,
                open: true,
                title: '',
                description: '',
                confirm: () => {
                    cleanData();
                    setSection(UserFilesSections.DETAIL);
                    filterAddFiles.cleanFilter();
                    getUserFilesAlreadyAdded();
                    closeModal();
                },
                children:
                    <Box sx={styles.children}>
                        <Typography sx={styles.icon}>{icons('check')}</Typography>
                        <Typography className="title">{t('filesManager.modal.description.filesHasbeenAdded', { count: isCheckedSee ? (totalItemsAdd - noSelectedSee.length) : selectedSee.length })}</Typography>
                    </Box>,
                back: undefined,

            }))
        }
        setLoadingSaveFiles(false)
    }

    const saveUserList = () => {
        setOpenModal((prev) => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.areYouSureToSaveThgeFileslist'),
            confirm: () => {
                handleSaveUserList()
                closeModal()
            },
            children: undefined,
            back: closeModal,
        }))
    }

    const handleSaveUserList = async () => {
        setLoadingSaveUserFiles(true)

        const body = addUserFilesBody({ arrayEdits, flagCheckedDownload, flagCheckedSee, selectedDownload, userId: Number(userId), isCheckedDownload, isCheckedSee, noSelectedDownload, noSelectedSee, selectedSee })


        const response = await filesManagerServiceFetch.addFilesToUser({ body: body, query: isCheckedSee ? returnQuery({ ...detailFilter.query, filter: detailFilter.query.filter?.replaceAll('+', '%2B') }, formatFilterList) : undefined })

        if (response.code == '00') {
            cleanData();
            detailFilter.cleanFilter();
            getUserFilesAlreadyAdded();
            setOpenSnackbar((prev) => ({
                ...prev,
                message: t('filesManager.modal.description.allFilesPermissionUpdated'),
                type: Types.SUCCESS,
                open: true,
            }))
        }
        //setSection(UserFilesSections.LIST)
        setLoadingSaveUserFiles(false)
    }

    const columnList = [
        {
            id: 'firstName',
            label: t('filesManager.columns.userName'),
            sortable: true,
            minWidth: 50
        },
        {
            id: 'role',
            label: t('filesManager.columns.role'),
            sortable: true
        },
        {
            id: 'areaName',
            label: t('filesManager.columns.area'),
            minWidth: 100,
            sortable: true,
            renderCell: (params: any) => {
                const areaArray = params.row.areaName ? params.row.areaName : undefined;
                const firstTwoArea = areaArray?.slice(0, 2);
                const remainingArea = areaArray?.slice(2);
                return (
                    <Box /* sx={styles.containerArea} */>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoArea?.join(', ')}
                            {remainingArea?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingArea.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!areaArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'departmentName',
            label: t('filesManager.columns.department'),
            minWidth: 100,
            sortable: true,
            renderCell: (params: any) => {
                const departmentArray = params.row.departmentName ? params.row.departmentName : undefined;
                const firstTwoDepartment = departmentArray?.slice(0, 2);
                const remainingDepartment = departmentArray?.slice(2);
                return (
                    <Box /* sx={styles.containerArea} */>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoDepartment?.join(', ')}
                            {remainingDepartment?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingDepartment.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!departmentArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'userType',
            label: t('filesManager.columns.userType'),
            sortable: true
        },
        {
            id: 'action',
            label: t('filesManager.columns.action'),
            //sortable: true,
            renderCell: (params: any) => {
                const id: number = params.row.id
                const user = {
                    name: !!params.row.firstName ? params.row.firstName : 'N/A',
                    role: !!params.row.role ? params.row.role : 'N/A',
                    area: params.row.areaName ?? 'N/A',
                    department: params.row.departmentName ?? 'N/A',
                    userType: !!params.row.userType ? params.row.userType : 'N/A',
                }
                return (
                    <Box sx={styles.containerAction}>
                        <IconButton onClick={() => { handleUserDetail(id, user) }}>{icons('search-file')}</IconButton>
                    </Box>
                )
            },
        }
    ]

    const cleanData = () => {
        setSelectedSee([]);
        setnoSelectedSee([]);
        setSelectedDownload([]);
        setnoSelectedDownload([]);
        setIsCheckedSee(false);
        setIsCheckedDownload(false);
        setIsChecked(false);
        setDeletedSelected([]);
        setFlagCheckedDownload(false);
        setFlagCheckedSee(false);
        setArrayEdits([]);
    }

    const closeOpenSnakbar = () => {
        setOpenSnackbar((prev) => ({
            ...prev,
            open: false,
        }))
    }

    const columnDetail = [
        {
            id: 'actions',
            minWidth: 20,
            column: () => {
                return (
                    <Box sx={styles.all}>
                        <Checkbox
                            checked={isChecked}
                            onChange={handleHeaderChange}
                            color="primary"
                        />
                    </Box>
                )
            },
            renderCell: (params: any) => {
                const isEditable = params.row.editable;
                return (<>
                    {isEditable &&
                        <Box sx={styles.action}>
                            <HeaderRowCheckBox
                                id={params.row.id}
                                isChecked={isChecked}
                                selectedIds={deleteSelected}
                                setSelectedIds={setDeletedSelected}
                                notFolioSelected={noDeleteSelected}
                                setNotFolioSelected={setnoDeletedSelected}
                                disabled={false}
                            />
                        </Box>
                    }
                </>)
            },
        },
        {
            id: 'fileName',
            label: t('filesManager.columns.fileName'),
            sortable: true,
            minWidth: 200,
            renderCell: (params: any) => {
                const fileName = params.row.fileName;
                const key = `${params.row.createdBy}/${params.row.fileName}`
                const canSee = params.row.canSee
                return (
                    <Tooltip title={fileName}>
                        {canSee ?
                            <Typography sx={styles.fileName} onClick={() => setViewFile({ fileKey: key, fileName })} >
                                {fileName}
                            </Typography>
                            :
                            <Typography sx={styles.fileNameNoSee}>
                                {fileName}
                            </Typography>
                        }
                    </Tooltip>
                )
            },
        },
        {
            id: 'createTime',
            label: t('filesManager.columns.creationDate'),
            sortable: true
        },
        {
            id: 'dateEnd',
            label: t('filesManager.columns.expirationDate'),
            sortable: true
        },
        {
            id: 'size',
            label: t('filesManager.columns.fileSize'),
            sortable: true
        },
        {
            id: 'seeFile',
            label: t('general.tags.seeFile'),
            minWidth: 100,
            column: () => {
                return (
                    <Box sx={styles.all}>
                        <Checkbox
                            className='remove-m'
                            name="delete"
                            checked={isCheckedSee}
                            onChange={handleHeaderSeeChange}
                            sx={{ m: 1 }}
                            color="primary"
                        />

                        <Typography sx={styles.checkLabel}>
                            {t('general.tags.seeFile')}
                        </Typography>
                    </Box>
                )
            },
            renderCell: (params: any) => {
                const isEditable = params.row.editable;
                const fileRecord = arrayEdits.find(item => item.idFile === params.row.id);
                const seeFile = fileRecord ? fileRecord.seeFile : params.row.seeFile;
                const otherValue = params.row.downloadFile;
                return (
                    <Box sx={styles.action}>
                        {!isEditable && (
                            <CheckCell value={params.row.seeFileIcon} />
                        )}

                        {isEditable && !flagCheckedSee && (
                            <Checkbox
                                name="downloadFile"
                                checked={seeFile}
                                onChange={(_, check) => {
                                    handleSelect({ id: params?.row?.id, value: check, name: 'seeFile', otherValue })
                                }}
                                sx={{ m: 1 }}
                            />
                        )}

                        {isEditable && flagCheckedSee && (
                            <HeaderRowCheckBox
                                id={params.row.id}
                                isChecked={isCheckedSee}
                                selectedIds={selectedSee}
                                setSelectedIds={setSelectedSee}
                                notFolioSelected={noSelectedSee}
                                setNotFolioSelected={setnoSelectedSee}
                                disabled={false}
                                closeModal={closeModal}
                                modal={{
                                    title: t('filesManager.modal.titles.deleteSettings'),
                                    description: t('filesManager.modal.description.deleteSettings'),
                                }}
                                setOpenModal={setOpenModal}
                                openModal={
                                    flagCheckedDownload
                                        ?
                                        isCheckedDownload
                                            ?
                                            !noSelectedDownload.includes(params.row.id)
                                            :
                                            selectedDownload.includes(params.row.id)
                                        :
                                        fileRecord !== undefined
                                            ?
                                            fileRecord.downloadFile
                                            :
                                            params.row.downloadFile
                                }
                            />
                        )}
                    </Box>
                )
            },
        },
        {
            id: 'downloadFile',
            label: t('general.tags.downloadFile'),
            minWidth: 100,
            headerCell: {
                '&.header-cell.header-cell': {
                    whiteSpace: 'normal'
                }
            },
            column: () => {
                return (
                    <Box sx={styles.all}>
                        <Checkbox
                            className='remove-m'
                            name="delete"
                            checked={isCheckedDownload}
                            onChange={handleHeaderDownloadChange}
                            color="primary"
                            disabled={!isCheckedSee}
                        />

                        <Typography sx={styles.checkLabel}>
                            {t('general.tags.downloadFile')}
                        </Typography>
                    </Box>
                )
            },
            renderCell: (params: any) => {
                const isEditable = params.row.editable;
                const fileRecord = arrayEdits.find(item => item.idFile === params.row.id);
                const downloadFile = fileRecord ? fileRecord.downloadFile : params.row.downloadFile;
                const otherValue =
                    flagCheckedSee
                        ?
                        isCheckedSee
                            ?
                            !noSelectedSee.includes(params.row.id)
                            :
                            selectedSee.includes(params.row.id)
                        :
                        params.row.seeFile;

                const disabled =
                    fileRecord
                        ?
                        fileRecord.seeFile
                        :
                        flagCheckedSee
                            ?
                            isCheckedSee
                                ?
                                !noSelectedSee.includes(params.row.id)
                                :
                                selectedSee.includes(params.row.id)
                            :
                            params.row.seeFile;

                return (
                    <Box sx={styles.action}>
                        {!isEditable && (
                            <CheckCell value={params.row.downloadFileIcon} />
                        )}

                        {isEditable && !flagCheckedDownload && (
                            <Checkbox
                                name="downloadFile"
                                checked={downloadFile}
                                disabled={!disabled}
                                onChange={(_, check) => {
                                    handleSelect({ id: params?.row?.id, value: check, name: 'downloadFile', otherValue })
                                }}
                                sx={{ m: 1 }}
                            />
                        )}

                        {isEditable && flagCheckedDownload && (
                            <HeaderRowCheckBox
                                id={params.row.id}
                                isChecked={isCheckedDownload}
                                selectedIds={selectedDownload}
                                setSelectedIds={setSelectedDownload}
                                notFolioSelected={noSelectedDownload}
                                setNotFolioSelected={setnoSelectedDownload}
                                disabled={
                                    (!isCheckedSee && !selectedSee.includes(params.row.id)) ||
                                    (isCheckedSee && noSelectedSee.includes(params.row.id))
                                }
                            />
                        )}

                    </Box>
                )
            },
        }
    ]

    const columnAddFile = [
        {
            id: 'fileName',
            label: t('filesManager.columns.fileName'),
            sortable: true,
            minWidth: 200,
            renderCell: (params: any) => {
                const fileName = params.row.fileName;
                const key = `${params.row.createdBy}/${params.row.fileName}`
                return (
                    <Tooltip title={fileName}>
                        <Typography sx={styles.fileName} onClick={() => setViewFile({ fileKey: key, fileName })} >
                            {fileName}
                        </Typography>
                    </Tooltip>
                )
            },
        },
        {
            id: 'createTime',
            label: t('filesManager.columns.creationDate'),
        },
        {
            id: 'type',
            label: t('filesManager.tags.fileType'),
        },
        {
            id: 'size',
            label: t('filesManager.columns.fileSize'),
            sortable: true
        },
        {
            id: 'seeFile',
            label: t('general.tags.seeFile'),
            minWidth: 100,
            column: () => {
                return (
                    <Box sx={styles.all}>
                        <Checkbox
                            checked={isCheckedSee}
                            onChange={handleHeaderSeeChange}
                            color="primary"
                        />
                        <Typography>{t('general.tags.seeFile')}</Typography>
                    </Box>
                )
            },
            renderCell: (params: any) => {
                return (
                    <Box sx={styles.action}>
                        <HeaderRowCheckBox
                            id={params.row.id}
                            isChecked={isCheckedSee}
                            selectedIds={selectedSee}
                            setSelectedIds={setSelectedSee}
                            notFolioSelected={noSelectedSee}
                            setNotFolioSelected={setnoSelectedSee}
                            disabled={false}
                            closeModal={closeModal}
                            modal={{
                                title: t('filesManager.modal.titles.deleteSettings'),
                                description: t('filesManager.modal.description.deleteSettings'),
                            }}
                            setOpenModal={setOpenModal}
                            openModal={isCheckedDownload ? !noSelectedDownload.includes(params.row.id) : selectedDownload.includes(params.row.id)}
                        />
                    </Box>
                )
            },
        },
        {
            id: 'downloadFile',
            label: t('general.tags.downloadFile'),
            minWidth: 100,
            headerCell: {
                '&.header-cell.header-cell': {
                    whiteSpace: 'normal',
                },
            },
            column: () => {
                return (
                    <Box sx={styles.all}>
                        <Checkbox
                            checked={isCheckedDownload}
                            onChange={handleHeaderDownloadChange}
                            color="primary"
                            disabled={!isCheckedSee}
                        />
                        <Typography>{t('general.tags.downloadFile')}</Typography>
                    </Box>
                )
            },
            renderCell: (params: any) => {
                return (
                    <Box sx={styles.action}>
                        <HeaderRowCheckBox
                            id={params.row.id}
                            isChecked={isCheckedDownload}
                            selectedIds={selectedDownload}
                            setSelectedIds={setSelectedDownload}
                            notFolioSelected={noSelectedDownload}
                            setNotFolioSelected={setnoSelectedDownload}
                            disabled={
                                (!isCheckedSee && !selectedSee.includes(params.row.id)) ||
                                (isCheckedSee && noSelectedSee.includes(params.row.id))
                            }
                        />
                    </Box>
                )
            },
        }
    ]

    const getUserFilesList = async () => {
        setTableLoading(true)
        const response = await filesManagerServiceFetch.getListUserWithFiles({ query: returnQuery({ ...filterFileList.query, filter: filterFileList.query.filter?.replaceAll('+', '%2B') }, formatFilterList) })
        const { row } = formatUserWithFilesList({ response })

        if (!response?.errors) {
            setRowList(row)
            setTotalPages(response.totalPages)
        }

        setTableLoading(false)
    }

    const getUserFilesAlreadyAdded = async () => {
        setTableUserLoading(true)
        if(Number(userId) == 0) { return }
        const response = await filesManagerServiceFetch.getListUserFiles({ query: returnQuery({ ...detailFilter.query, filter: detailFilter.query.filter?.replaceAll('+', '%2B') }, formData), userId: Number(userId) })
        const { row } = formatUserFilesList({ response, userId: state.id, userRole: state.role })

        if (!response?.errors) {
            setRowDetail(row)
            setTotalPagesDetail(response.totalPages)
        }

        setTableUserLoading(false)
    }

    const getMyFilesList = async () => {
        if(Number(userId) == 0) { return }
        setTableAddLoading(true)
        const response = await filesManagerServiceFetch.getMyListFiles({ query: returnQuery({ ...filterAddFiles.query, filter: filterAddFiles.query.filter?.replaceAll('+', '%2B') }, formData), userId: Number(userId) })
        const { row } = formatUserFilesToAddList({ response })

        if (!response?.errors) {
            setRowAddFile(row)
            setTotalPagesAdd(response.totalPages)
            setTotalItemsAdd(response.totalItems)
        }

        setTableAddLoading(false)
    }

    useEffect(() => {
        if (refTime.current) { clearTimeout(refTime.current) }

        refTime.current = setTimeout(() => {
            getUserFilesList()
        }, 300)
    }, [filterFileList.query.all])

    useEffect(() => {
        if (userId) {
            getUserFilesAlreadyAdded();
        }
    }, [userId])

    useEffect(() => {
        if (refTimeSecond.current) { clearTimeout(refTimeSecond.current) }

        refTimeSecond.current = setTimeout(() => {
            getMyFilesList();
        }, 300)
    }, [filterAddFiles.query.all])

    useEffect(() => {
        if (refTimeDetail.current) { clearTimeout(refTimeDetail.current) }

        refTimeDetail.current = setTimeout(() => {
            getUserFilesAlreadyAdded();
        }, 300)
    }, [detailFilter.query.all])

    useEffect(() => {

        const prev = prevNoSelectedSeeRef.current;
        const current = noSelectedSee;

        // Detectar IDs agregados a noSelectedSee (antes no estaban, ahora sí)
        const addedIds = current.filter(id => !prev.includes(id));
        // Detectar IDs eliminados de noSelectedSee (antes estaban, ahora no)
        const removedIds = prev.filter(id => !current.includes(id));

        if (section == UserFilesSections.ADD_FILE) {
            if (isCheckedDownload) {
                setnoSelectedDownload((prev) => {
                    // Agrega solo los IDs que no estén ya en prev
                    const nuevosIds = noSelectedSee.filter(id => !prev.includes(id));
                    return [...prev, ...nuevosIds];
                });
            } else {
                setSelectedDownload(prev => prev.filter(id => !noSelectedSee.includes(id)));
            }
        }

        if (section == UserFilesSections.DETAIL && flagCheckedSee && flagCheckedDownload) {
            if (isCheckedDownload) {
                setnoSelectedDownload((prev) => {
                    // Agrega solo los IDs que no estén ya en prev
                    const nuevosIds = noSelectedSee.filter(id => !prev.includes(id));
                    return [...prev, ...nuevosIds];
                });
            } else {
                setSelectedDownload(prev => prev.filter(id => !noSelectedSee.includes(id)));
            }
        }

        if (section == UserFilesSections.DETAIL && flagCheckedSee && !flagCheckedDownload) {
            setArrayEdits(prev => {
                let updated = [...prev];

                // Caso: ID agregado → ver = false, download = false
                addedIds.forEach(id => {
                    const exists = updated.find(item => item.idFile === id);
                    if (exists) {
                        exists.seeFile = false;
                        exists.downloadFile = false;
                    } else {
                        updated.push({ idFile: id, seeFile: false, downloadFile: false });
                    }
                });

                // Caso: ID eliminado → ver = true, download = false
                removedIds.forEach(id => {
                    const exists = updated.find(item => item.idFile === id);
                    if (exists) {
                        exists.seeFile = true;
                        exists.downloadFile = false;
                    } else {
                        updated.push({ idFile: id, seeFile: true, downloadFile: false });
                    }
                });

                return updated;
            });
        }

        prevNoSelectedSeeRef.current = current;

    }, [noSelectedSee])

    useEffect(() => {
        if (section == UserFilesSections.ADD_FILE) {
            const prevSelectedSee = prevSelectedSeeRef.current;

            const removedIds = prevSelectedSee.filter(id => !selectedSee.includes(id));

            if (removedIds.length > 0) {
                setSelectedDownload(prev => prev.filter(id => !removedIds.includes(id)));
            }

            prevSelectedSeeRef.current = selectedSee;
        }

        if (section == UserFilesSections.DETAIL && flagCheckedSee && flagCheckedDownload) {
            const prevSelectedSee = prevSelectedSeeRef.current;

            const removedIds = prevSelectedSee.filter(id => !selectedSee.includes(id));

            if (removedIds.length > 0) {
                setSelectedDownload(prev => prev.filter(id => !removedIds.includes(id)));
            }

            prevSelectedSeeRef.current = selectedSee;
        }
    }, [selectedSee]);


    return {
        columnList,
        rowList,
        columnDetail,
        rowDetail,
        openModal,
        closeModal,
        deleteSelected,
        setDeletedSelected,
        deletedUsersSelecteds,
        input,
        detailFilter,
        isChecked,
        columnAddFile,
        handleAddFiles,
        saveUserList,
        unSelectOrSelectAllFiles,
        tableLoading,
        totalPages,
        tableUserLoading,
        filterAddFiles,
        rowAddFile,
        totalPagesAdd,
        tableAddLoading,
        disabledAddFiles,
        totalPagesDetail,
        getMyFilesList,
        getUserFilesAlreadyAdded,
        cleanData,
        loadingSaveFiles,
        loadingDeleteFiles,
        closeOpenSnakbar,
        openSnackbar,
        loadingSaveUserFiles,
        disabledSaveUserFiles,
        viewFile,
        setViewFile
    }
}



export { useTable }